export default __webpack_public_path__ + "static/media/ep1.1292f348.png";